import { createUseRBAC } from 'features/Auth/utils/hooks/useRBAC'

export const flexiComboRolesRBAC = {
  pageID: 'b45fef4fd68bfe641173f36821b41e39',
  elementID: {
    ViewPageList: 'ac7ebf485ff41b3d9924dea998564943',
    ToggleStatus: '91aaea391bf90d4cece2d4764ccd23f3',
    ButtonCreateFlexiCombo: '0da9b3bbcf73cb5e3c7f2c47a4042d25',
    ButtonEditFlexiCombo: '2fcbf9a429fe2d20e706b84614a9a089',
  },
} as const

export const useRBACFlexiComboPage = createUseRBAC(flexiComboRolesRBAC.elementID)

export type UseRBACFlexiComboPageType = ReturnType<typeof useRBACFlexiComboPage>
